import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuildersLocations } from '../../../../../selectors/locations';
import { ISuggestion } from '../../../../../components/Filters';

export const useLocationSearch = () => {
  const [searchQuery, setSearchQuery] = React.useState('');
  const locations = useSelector(selectBuildersLocations);

  const handleLocationSearch = useEventCallback((query: string) => {
    setSearchQuery(query);
  });

  const suggestions = React.useMemo(() => {
    if (!searchQuery) {
      return [];
    }

    return locations.reduce<ISuggestion[]>((result, location) => {
      const { id, name } = location;
      const matchIndex = location.name.toLowerCase().indexOf(searchQuery.toLowerCase());

      if (matchIndex !== -1) {
        result.push({
          id,
          match: name.slice(matchIndex, matchIndex + searchQuery.length),
          prefix: name.slice(0, matchIndex),
          suffix: name.slice(matchIndex + searchQuery.length),
        });
      }

      return result;
    }, []);
  }, [locations, searchQuery]);

  return {
    searchQuery,
    handleLocationSearch,
    suggestions,
  };
};
